module.exports = __webpack_public_path__ + "Icono_ProgramaCX_126px.png";